import React from 'react'
import {
    Subtitle,
    ContentForm,
    LabelGeneralForumPage,
    ValueGeneralInfoForumPage,
    HelpDescription,
    checkboxStyle,
    factorsLabelStyle,
    horizontalRowLine,
    DescriptionTag,
    ValueGeneralInfoSemiBoldForumPage,
} from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/LondonProtocol/styles'
import { InputLabel } from 'components/InputLabel'
import { Label } from 'components/InputLabel/styles'
import { InputSelect } from 'components/InputSelect'
import { Toggle } from 'components/Toggle'
import { LabelsForInput } from 'components/LabelsForInputs'
import { TextArea } from 'components/TextArea'
import Checkbox from 'components/InputCheckbox'
import { CustomDatePicker } from 'components/Datepicker'
import { stringToDate } from 'utils/dateUtils'
import { getCorIncidente, getDamage, getDateTime } from 'utils/damage'
import { getLabelByValue } from '../../helper'
import { InfoContent, InfoText, InfoTextTitle } from '../../../NotificationData/styles'
import NumberOrBulletTextArea from 'components/NumberOrBulletTextArea'
import YellowCircleInterrogation from 'components/Icons/YellowCircleInterrogation'
import { inputRequiredStyle } from '../../styles'
import { NotificationReducer, NotificationType } from 'types/notification'

export interface LondonProtocolFormFieldsBodyV3Props {
    register: any
    control: any
    setValue: any
    getValues: any
    errors: any
    notification: NotificationType | undefined
    notificationSelector: NotificationReducer
    protocoloLondon: any
    protocoloNotificationFactors: Record<string, any[]>
    londonVaribles: any
    typesOfDiagnosis: { label: string; value: string }[]
    organizationalConsequences: any[]
    chronologicalReportValue: string
    onChangeHelper: () => void
    notAllowed: boolean
    getTreatmentNumber: () => string | undefined
    neverEventDisplay: string
    sentinelEventDisplay: string
    omsClassifications: any[]
    setShowModal: (open: boolean) => void
    onlyProfilecanInputNSPOpinion: boolean
    scrollInnerClassName?: string
    /** Em grupo: primeiro campo mostra chave do grupo, não da notificação. */
    context?: 'individual' | 'group'
    /** Valor exibido em "Chave do grupo" quando `context === 'group'`. */
    groupKeyDisplay?: string
}

export const LondonProtocolFormFieldsBodyV3 = ({
    register,
    control,
    setValue,
    getValues,
    errors,
    notification,
    notificationSelector,
    protocoloLondon,
    protocoloNotificationFactors,
    londonVaribles,
    typesOfDiagnosis,
    organizationalConsequences,
    chronologicalReportValue,
    onChangeHelper,
    notAllowed,
    getTreatmentNumber,
    neverEventDisplay,
    sentinelEventDisplay,
    omsClassifications,
    setShowModal,
    onlyProfilecanInputNSPOpinion,
    scrollInnerClassName,
    context = 'individual',
    groupKeyDisplay = ''
}: LondonProtocolFormFieldsBodyV3Props) => {
    const isGroup = context === 'group'
    const innerColSpan = 'col-span-2'
    const wideRead = 'w-[1024px] max-w-full min-w-0'
    const diagContainer = 'w-[660px] min-w-0 max-w-full'
    const diagOptions = 'w-[660px] max-w-full top-[55px]'
    const orgSel = 'w-[1120px] min-w-0 max-w-full'
    const orgOpts = 'w-[1120px] max-w-full top-[55px]'
    const maxWideField = 'max-w-[1120px]'
    const maxConvenio = 'max-w-[552px]'
    const patientCareClass = 'w-[363px] max-w-[552px]'

    return (
                            <ContentForm>
                                <div className={`flex min-w-0 w-full flex-col ${innerColSpan}`}>
                                    <div className={scrollInnerClassName ?? 'h-[696px] px-8 mt-1 mb-1'}>
                                        <div id="general-info">
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Informações gerais da notificação
                                            </Subtitle>
                                            <div className="grid grid-cols-4 gap-4">
                                                <InfoContent>
                                                    <InfoTextTitle>
                                                        {isGroup ? 'Chave do grupo' : 'Chave da notificação'}
                                                    </InfoTextTitle>
                                                    <InfoText $bold>
                                                        {isGroup
                                                            ? (groupKeyDisplay?.trim() ? groupKeyDisplay.trim() : '—')
                                                            : notification?.number?.display_value}
                                                    </InfoText>

                                                    <div className="mt-2">
                                                        <span
                                                            className={`chip-incidente incidente-${getCorIncidente(
                                                                getDamage(
                                                                    notification?.damage_level?.value
                                                                )?.value
                                                            )}`}
                                                        >
                                                            {`${getDamage(
                                                                notification?.damage_level?.value
                                                            )?.label
                                                                }`}
                                                        </span>
                                                    </div>

                                                </InfoContent>
                                                <div>
                                                    <LabelGeneralForumPage>Data da notificação</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{
                                                        getDateTime(notification?.sys_created_on?.value)
                                                    }</ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Setor notificante</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.reporter_sector?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                                <div className='ml-[265px] w-full'>
                                                    <LabelGeneralForumPage>Notificante</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.reporter_name?.display_value || 'Anônimo'}</ValueGeneralInfoForumPage>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-4 gap-4 w-full">
                                                <div>
                                                    <Label></Label>
                                                    <span></span>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Data da ocorrência</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.date_incident?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Setor notificado</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.incident_sector?.display_value}</ValueGeneralInfoForumPage>
                                                </div>

                                                <div className='ml-[265px] w-full'>
                                                    <LabelGeneralForumPage>Turno que o evento ocorreu</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.shift_incident?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-4 gap-4 mt-7">
                                                <div>
                                                    <LabelGeneralForumPage>Iniciais do nome do paciente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage style={{ wordBreak: 'break-all' }}>
                                                        {notification?.patient_initials?.display_value}
                                                    </ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Data de nascimento</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.patient_date_of_birth?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Prontuário</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>
                                                        {notification?.document_type?.value !== 'atendimento' && notification?.document_number?.value ? (notification?.document_number?.value) : ("-")}
                                                    </ValueGeneralInfoForumPage>
                                                </div>

                                                <div>
                                                    {getTreatmentNumber() ?
                                                        (<>
                                                            <LabelGeneralForumPage>Número do atendimento</LabelGeneralForumPage>
                                                            <ValueGeneralInfoForumPage>
                                                                {getTreatmentNumber()}
                                                            </ValueGeneralInfoForumPage>
                                                        </>) : (<>
                                                            {notificationSelector?.notificationById &&
                                                                notificationSelector?.notificationById.document_type?.value === 'prontuario' ?
                                                                (<>
                                                                    <ValueGeneralInfoForumPage>
                                                                        <Label>Número do atendimento | {protocoloLondon?.u_patient_care_number} </Label>
                                                                        <InputLabel
                                                                            errorStyle='-bottom-[18px]'
                                                                            className={patientCareClass}
                                                                            name="u_patient_care_number"
                                                                            register={register}
                                                                            required={true}
                                                                            placeholder="Digite aqui"
                                                                            maxLength={80}
                                                                            error={{
                                                                                message: errors.u_patient_care_number
                                                                                    ? 'Preenchimento obrigatório.'
                                                                                    : ''
                                                                            }} />
                                                                    </ValueGeneralInfoForumPage>
                                                                </>) : (<>

                                                                </>)}
                                                        </>)}
                                                </div>

                                            </div>
                                        </div>

                                        <div className='my-6'>
                                            <Label>Convênio</Label>
                                            <HelpDescription>
                                                Informar também se for Particular ou SUS no campo abaixo
                                            </HelpDescription>
                                            <InputLabel
                                                required={true}
                                                errorStyle='-bottom-[18px]'
                                                name="patients_health_insurance"
                                                register={register}
                                                className={`${maxConvenio} ${errors.patients_health_insurance ? inputRequiredStyle : ''}`}
                                                placeholder="Digite aqui"
                                                maxLength={80}
                                                error={{
                                                    message: errors.patients_health_insurance
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''
                                                }}
                                            />
                                        </div>

                                        <div className="mt-6">
                                            <div className={`${!errors.date_of_patient_admission ? 'mb-6' : ''} w-[195px]`}>
                                                <CustomDatePicker
                                                    disabled={notAllowed}
                                                    name="date_of_patient_admission"
                                                    control={control}
                                                    required={true}
                                                    label="Data da internação do paciente"
                                                    placeholderData="Selecione"
                                                    dateValue={stringToDate(
                                                        notification?.date_of_patient_admission?.display_value,
                                                        'dd/MM/yyyy',
                                                        '/'
                                                    )}
                                                    maxDate={new Date()}
                                                    isError={!!errors.date_of_patient_admission}
                                                />
                                                <span className='text-errorText text-xs'>{errors.date_of_patient_admission
                                                    ? 'Preenchimento obrigatório.'
                                                    : ''}</span>
                                            </div>
                                            <div>
                                                <InputSelect
                                                    searchPlaceHolder="Buscar"
                                                    shouldHaveSearch={true}
                                                    errorTextStyle='-bottom-[18px]'
                                                    required={true}
                                                    label="Diagnóstico do paciente"
                                                    styleContainer={diagContainer}
                                                    styleBoxOptions={diagOptions}
                                                    name="types_of_diagnosis"
                                                    control={control}
                                                    data={typesOfDiagnosis}
                                                    placeholder="Selecione"
                                                    errorStyle={`${errors.types_of_diagnosis ? inputRequiredStyle : ''
                                                        }`}
                                                />

                                            </div>
                                        </div>

                                        <div className="w-full mt-6">
                                            <TextArea
                                                label='Time de investigação do evento'
                                                subLabel='Informar também o cargo dos colaboradores envolvidos'
                                                required={true}
                                                name="event_investigation_team"
                                                register={register}
                                                className={`${maxWideField} h-[70px] ${errors.event_investigation_team && inputRequiredStyle}`}
                                                placeholder="Digite aqui"
                                                rows={8}
                                                error={{
                                                    message: errors.event_investigation_team
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''
                                                }}
                                            />
                                        </div>
                                        <hr className={horizontalRowLine} />
                                        <div id="incident_analysis">
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Análise do incidente
                                            </Subtitle>
                                            <div className='mt-6'>
                                                <div>
                                                    <LabelGeneralForumPage>Título do incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.incident_title?.display_value ? notification?.incident_title?.display_value : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>

                                            </div>
                                            <div className={`${wideRead} mt-6`}>
                                                <div>
                                                    <LabelGeneralForumPage>Descrição do incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.incident_description?.display_value ? notification?.incident_description?.display_value : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>

                                            </div>
                                            <div className={`${wideRead} mt-6`}>
                                                <div>
                                                    <LabelGeneralForumPage>Ação corretiva imediata</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.immediate_corrective_action?.display_value ? notification?.immediate_corrective_action?.display_value : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                            </div>

                                        </div>

                                        <hr className={horizontalRowLine} />

                                        <div id="incident-detail" className='my-6'>
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Detalhes do incidente
                                            </Subtitle>
                                            <div className="grid grid-cols-2 gap-2 mt-4">
                                                <div>
                                                    <LabelGeneralForumPage>Tipo de Incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.incident_type?.display_value}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Classificação do Incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${getDamage(notification?.damage_level?.value)?.label}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-2 mt-6">
                                                <div>
                                                    <Label>Probabilidade de ocorrência do incidente</Label>
                                                    <Toggle
                                                        isError={!!errors?.probability}
                                                        required={true}
                                                        register={register}
                                                        name="probability"
                                                        itens={londonVaribles?.probability?.sort((a, b) => a.index - b.index)?.map(
                                                            (t) => ({
                                                                title: t.label,
                                                                value: t.value
                                                            })
                                                        )}
                                                        defaultCheckedValue="Nunca ocorreu"
                                                    />
                                                    <span className='text-errorText text-xs'>{errors.probability
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''}</span>
                                                </div>
                                                <div>
                                                    <Label>Análise de tolerabilidade</Label>
                                                    <Toggle
                                                        isError={!!errors?.tolerability_analysis}
                                                        required={true}
                                                        register={register}
                                                        name="tolerability_analysis"
                                                        itens={londonVaribles?.tolerability_analysis?.sort((a, b) => a.index - b.index)?.map(
                                                            (t) => ({
                                                                title: t.label,
                                                                value: t.value
                                                            })
                                                        )}
                                                        defaultCheckedValue="Tolerável"
                                                    />
                                                    <span className='text-errorText text-xs'>{errors.tolerability_analysis
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''}</span>
                                                </div>

                                            </div>
                                        </div>

                                        <hr className={horizontalRowLine} />

                                        <div id="extra-information" className='my-6'>
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Informações extras
                                            </Subtitle>
                                            <div className="grid grid-cols-1 gap-1 mt-4">
                                                <div>
                                                    <div>
                                                        <LabelGeneralForumPage>Classificação do incidente de acordo com a OMS - Organização Mundial de Saúde</LabelGeneralForumPage>
                                                        <ValueGeneralInfoSemiBoldForumPage>{`${notification?.u_oms_classification?.display_value ? getLabelByValue(omsClassifications, 'value', notification?.u_oms_classification?.value) : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                    </div>
                                                </div>
                                                <div className='mt-4'>
                                                    <LabelGeneralForumPage>Never Events - ANVISA</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{neverEventDisplay}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                                <div className='mt-4'>
                                                    <LabelGeneralForumPage>Evento Sentinela - JCI</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{sentinelEventDisplay}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                                <div className='mt-4'>                                                    
                                                    <InputSelect
                                                        searchPlaceHolder="Buscar"
                                                        errorTextStyle='-bottom-[18px]'
                                                        required={false}
                                                        label="Consequências organizacionais"
                                                        styleContainer={orgSel}
                                                        styleBoxOptions={orgOpts}
                                                        name="organizational_consequences"
                                                        control={control}
                                                        data={organizationalConsequences}
                                                        placeholder="Selecione"
                                                        errorStyle={`${errors.organizational_consequences ? inputRequiredStyle : ''}`}
                                                    />

                                                    <div className="w-full mt-6">
                                                        <LabelsForInput
                                                            title="Relato cronológico do evento"
                                                            subtitle=""
                                                        />

                                                        <NumberOrBulletTextArea
                                                            maxLength={50000}
                                                            inputLength={50000 - chronologicalReportValue.length}
                                                            required={true}
                                                            onChangeHelper={onChangeHelper}
                                                            isDotOrNumber="number"
                                                            setValue={setValue}
                                                            getValues={getValues}
                                                            register={register}
                                                            defaultValue={notification?.chronological_report?.display_value}
                                                            name="chronological_report"
                                                            textAreaStyle={`${maxWideField} h-[260px] ${errors.chronological_report && inputRequiredStyle}`}
                                                            placeholder="1. Digite aqui"
                                                            rows={8}
                                                            error={{
                                                                message: errors.chronological_report
                                                                    ? 'Preenchimento obrigatório.'
                                                                    : ''
                                                            }}
                                                        />

                                                    </div>
                                                    <div className="w-full mt-6">
                                                        <LabelsForInput
                                                            title="Pontos fortes da assistência prestada e problemas no manejo dos cuidados"
                                                            subtitle="Resuma brevemente as principais conclusões da investigação e da assistência prestada, indicando tanto a boa prática quanto os problemas identificados."
                                                        />
                                                        <TextArea
                                                            name="u_strengths_of_the_care_provided_and_problems_in_managing_care"
                                                            register={register}
                                                            className={`h-[80px]`}
                                                            placeholder="Digite aqui"
                                                            rows={8}
                                                        />

                                                    </div>
                                                    <div className="w-full mt-6">
                                                        <div className="flex text-right items-center pb-1">
                                                            <LabelsForInput title="Fonte de dados e métodos" />
                                                            <div className="flex items-center ml-1 cursor-pointer" onClick={() => setShowModal(true)}>
                                                                <YellowCircleInterrogation />
                                                                <span className="ml-2 text-sm underline font-semibold text-blueTheme">
                                                                    Saiba mais
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <TextArea
                                                            name="u_data_source_and_methods"
                                                            register={register}
                                                            className={`h-[80px]`}
                                                            placeholder="Digite aqui"
                                                            rows={8}
                                                        />

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <hr className={horizontalRowLine} />
                                        <div id="contributing-factors" className='my-6'>
                                            <Subtitle className='text-blueTheme font-bold'> Fatores contribuintes </Subtitle>
                                            <div id='patient-factors'>
                                                <div className='my-5'>
                                                    <Label>Fatores do paciente</Label>
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.patient_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="patient_factors"
                                                        onChange={() => { }}
                                                    />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_patient_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='individual-factors ' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores individuais (colaboradores)" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.individual_factors_people || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="individual_factors_people"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_individual_factors_people_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='task-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Tarefas" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.task_factors_and_technology || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="task_factors_and_technology"
                                                        onChange={() => { }}
                                                    />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_task_factors_and_technology_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='team-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores da equipe" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.team_factors_teams || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="team_factors_teams"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_team_factors_teams_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='work-environment' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores do ambiente de trabalho" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.work_environment_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="work_environment_factors"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_work_environment_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='task-technology-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Tecnologia e sistemas eletrônicos de informação" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.technology_and_electronic_information_systems || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="u_technology_and_electronic_information_systems"
                                                        onChange={() => { }}
                                                    />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_description_technology_and_electronic_information_systems"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='organizational-managerial-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores organizacionais, gerenciais e culturais" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.organizational_and_managerial_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="organizational_and_managerial_factors"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_organizational_and_managerial_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='institutional-context-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores de contexto Institucional" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.institutional_context_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="institutional_context_factors"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_institutional_context_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='patient-support-factors' className='mt-6 mb-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Apoio a pacientes, familiares e equipe" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.support_for_patients_families_and_staff || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="u_support_for_patients_families_and_staff"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_description_support_for_patients_families_and_staff"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>
                                            <hr className={horizontalRowLine} />

                                            { 
                                            onlyProfilecanInputNSPOpinion && <div id='nsp-factors' className='pb-8 mt-6'>
                                                <Label>Parecer do NSP</Label>
                                                <HelpDescription>
                                                    Campo destinado à Qualidade da Unidade (opcional)
                                                </HelpDescription>
                                                <Toggle
                                                    required={false}
                                                    register={register}
                                                    name="u_nsp_opinion"
                                                    itens={protocoloNotificationFactors?.nsp_opinion?.map(
                                                        (t) => ({
                                                            title: t.label,
                                                            value: t.value
                                                        })
                                                    )}
                                                    defaultCheckedValue="Tolerável"
                                                />
                                                <div className='mt-4'>
                                                    <DescriptionTag>Comentário</DescriptionTag>
                                                    <TextArea
                                                        name="u_description_nsp_opinion"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>
                                            }                                         

                                        </div>

                                    </div>
                                </div>

                            </ContentForm>

    )
}
